import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    siteConfig: [],
    projectConfig: {
        config:[]
    },
    siteConfigTips:null
};
const getters = {
    siteConfig: () => state.siteConfig,
    projectConfig: () => state.projectConfig,
    siteConfigTips: () => state.siteConfigTips
};

const actions = {
    [actionType.GET_PROJECT_CONFIG]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/site-configs/styles').then(result => {
                if(result.data.data) {
                    commit(mutationType.SET_PROJECT_CONFIG, result.data.data)
                }
                resolve(result.data.data)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.SET_PROJECT_CONFIG]: async function ({ commit }, params) {
        
        return new Promise((resolve, reject) => {
            api.put(`/site-configs/styles`, {
                header_html: params.header_html,
                header_style: params.header_style,
                footer_html: params.footer_html,
                footer_style: params.footer_style,
                favicon_url: params.favicon_url,
                affiliate: params.affiliate,
                affiliate_url: params.affiliate_url,
                header_logo_svg: params.header_logo_svg,
                logo_svg: params.logo_svg,
                loading_icon_url: params.loading_icon_url,
                primary_color: params.primary_color,
                category_color_residence: params.category_color_residence,
                category_color_commercial: params.category_color_commercial,
                category_color_land: params.category_color_land,
                category_color_newproject: params.category_color_newproject,
                cancel_button_color: params.cancel_button_color,
                home_subtitle: params.home_subtitle,
                home_title: params.home_title,
                meta_keywords: params.meta_keywords,
                meta_description: params.meta_description,
                meta_image: params.meta_image,
                radio_button: params.radio_button //"STRING | TEXT | NUMBER"
            })
            .then(result => {
                
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.GET_SITE_CONFIG]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/site-configs', {
                params: {
                    take: params.take || 10,
                    page: params.page || 1,
                    key: params.key,
                }
            }).then(result => {
                if(result.data.data) {
                    commit(mutationType.SET_SITE_CONFIG, result.data.data)
                }
            })
            .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_SITE_CONFIG]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/site-configs/update/${params.id}`, {
                name: params.name,
                value: params.value,
                type: params.type //"STRING | TEXT | NUMBER"
            })
            .then(result => {
                if(result.data.data) {
                    commit(mutationType.UPDATE_SITE_CONFIG, result.data.data)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    
    [actionType.GET_SITE_TIPS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/site-configs/tips').then(result => {
                if(result.data.data) {
                    commit(mutationType.SET_SITE_TIPS, result.data.data)
                }
            })
            .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_SITE_TIPS]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.put(`/site-configs/tips`, {
                tips_admin_dashboard: params.tips_admin_dashboard,
                tips_user_dashboard: params.tips_user_dashboard
            })
            .then(result => {
                if(result.data.success === true) {
                    commit(mutationType.SET_SITE_TIPS, params)
                }
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
    [mutationType.SET_PROJECT_CONFIG]: function (state, data) {
        state.projectConfig = data;
    },
    [mutationType.SET_SITE_CONFIG]: function (state, data) {
        state.siteConfig = data;
    },
    [mutationType.UPDATE_SITE_CONFIG]: function (state, data) {
        if(state.siteConfig.length) {
            state.siteConfig[0] = data;
        }
        
    },
    [mutationType.SET_SITE_TIPS]: function (state, data) {
        state.siteConfigTips = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}